import { useTranslation } from 'react-i18next';
import type { SceneStore } from '@os/doc';
import { Dialog, ListItem } from '../../ui';
import { pageLabel } from './labels';

/**
 * The page a link shows (P14): every page but the active one (a link to its own page would show itself), plus
 * « Nouvelle page » when there is no other page yet. `onPick` gets the chosen page's id.
 */
export function PageLinkDialog({ store, onPick, onClose }: { store: SceneStore; onPick: (pageId: string) => void; onClose: () => void }) {
  const { t } = useTranslation();
  const pages = store.pages();
  const others = pages.flatMap((p, i) => (p.id === store.page ? [] : [{ p, i }]));
  return (
    <Dialog title={t('pages.linkTitle')} description={t('pages.linkHint')} onClose={onClose}>
      <ul className="flex flex-col gap-1">
        {others.map(({ p, i }) => (
          <li key={p.id}>
            <ListItem label={pageLabel(t, p, i)} onClick={() => onPick(p.id)} />
          </li>
        ))}
        {others.length === 0 && (
          <li>
            <ListItem
              label={t('pages.new')}
              onClick={() => {
                const id = store.commands.addPage({ after: store.page });
                if (id) onPick(id);
              }}
            />
          </li>
        )}
      </ul>
    </Dialog>
  );
}
